<div class="container">
  <ul class="breadcrumb">
    <li><strong>Onde estou:</strong></li>
    <li class="active">
      <span id="lblSubMenu">Cadastro - Postos - <b>Ajuste Preços Combustível</b></span>
    </li>
  </ul>
  <div class="container-tela">
    <div class="row">
      <div class="col-6">
        <h3 class="enif-title">Selecione o combustível desejado e atualize o <strong
          class="enif-uppercase">Preço.</strong>
        </h3>
      </div>
      <div class="col-4 float-end">
        <button class="btn btn-terceary float-end" routerLink="/login?cmdName=acesso-livre">Atualizar precos via planilha</button>
      </div>

      <div class="col-2 float-left">
        <button class="btn btn-secondary" data-toggle="modal" data-target="#ajudaModal"
                (click)="open(ajudaModel)"><i class="fa fa-question-circle-o" aria-hidden="true"></i>&nbsp;&nbsp;
          Ajuda
        </button>
      </div>
    </div>


    <ul class="nav justify-content-center">
      <li class="nav-item">
        <a class="nav-link btn btn-secondary btn-combustivel"
           [ngClass]="{'btn-selecionado' : combustivelSelecionado == 'S'}"
           href="javascript:void(0)" (click)="openGas('S');">
          <div>
            Diesel S10
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link btn btn-secondary btn-combustivel"
           [ngClass]="{'btn-selecionado' : combustivelSelecionado == 'A'}"
           href="javascript:void(0)" (click)="openGas('A');">
          <div>
            Diesel
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link btn btn-secondary btn-combustivel"
           [ngClass]="{'btn-selecionado' : combustivelSelecionado == 'B'}"
           href="javascript:void(0)" (click)="openGas('B');">
          <div>
            Gasolina
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link btn btn-secondary btn-combustivel"
           [ngClass]="{'btn-selecionado' : combustivelSelecionado == 'C'}"
           href="javascript:void(0)" (click)="openGas('C');">
          <div>
            Álcool
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link btn btn-secondary btn-combustivel"
           [ngClass]="{'btn-selecionado' : combustivelSelecionado == 'D'}"
           href="javascript:void(0)" (click)="openGas('D');">
          <div>
            Gasolina Aditivada
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link btn btn-secondary btn-combustivel"
           [ngClass]="{'btn-selecionado' : combustivelSelecionado == 'E'}"
           href="javascript:void(0)" (click)="openGas('E');">
          <div>
            Álcool
            Aditivado
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link btn btn-secondary btn-combustivel"
           [ngClass]="{'btn-selecionado' : combustivelSelecionado == 'T'}"
           href="javascript:void(0)" (click)="openGas('T');">
          <div>
            Diesel S10 Aditivado
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link btn btn-secondary btn-combustivel"
           [ngClass]="{'btn-selecionado' : combustivelSelecionado == 'U'}"
           href="javascript:void(0)" (click)="openGas('U');">
          <div>
            Arla
          </div>
        </a>
      </li>
    </ul>

    <div class="notificacoes" *ngIf="notificacaoTela" #notificacao>
      <div class="alert" [ngClass]="notificacaoStatus">
        <a href="javascript:void(0)" (click)="fecharNotificacao()" class="close" data-dismiss="alert"
           aria-label="fechar">X</a>
        <ul *ngFor="let item of notificacaoMensagens">
          <li>{{item}}</li>
        </ul>
      </div>

    </div>

    <div [ngSwitch]="this.combustivelSelecionado">
      <div id="S10" *ngSwitchCase="'S'" class="w3-container city m-5">
        <div *ngFor="let item of this.combustiveis">
          <div *ngIf="item.indCombustivel == 'S'">
            <div class="container text-center" *ngFor="let preco of item.combustivel.precos">
              <div class="row  justify-content-center">
                <div class="col-2 centralizado">
                  <h3 class="text-left comb-titulo">{{ preco.titulo }}</h3>
                  <p class="lable-preco text-left comb-descricao">{{ preco.descricao }} </p>
                </div>

                <div class="col-3 centralizado">

                  <svg mat-raised-button
                       matTooltip="Alteração: {{  item.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ item.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ item.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
                       aria-label="Button that displays a tooltip when focused or hovered over"
                       matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                       data-container="body" data-toggle="popover" data-trigger="hover"
                       xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                       class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                    <path
                      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                  </svg>
                </div>
                <div class="col-4">
                  <input currencyMask type="text" id="fname" name="fname"
                         [(readonly)]="preco.somenteLeitura" [(ngModel)]="preco.preco" autofocus="true"
                         maxlength="9" (keyup)="inputChange($event, preco, 9,'9,99')"
                         (blur)="inputChange($event, preco, 9,'9,99')"
                         (change)="inputChange($event, preco, 9,'9,99')"
                         [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                         [max]="9.999">
                  <p class="situacao-text alt-margin-bottom" *ngIf="preco.id == 'precoNegociado'">
                    Situação: <b>{{item.combustivel.dscStatusAcordo || "Informação ausente no momento"}}</b>
                  </p>
                </div>
                <div class="col-2 centralizado">
                  <button
                    class="btn btn-terceary" (click)="openAjustePreco(ajustePreco, preco, item)">
                    <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;&nbsp;Alterar
                  </button>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>

      <div id="Diesel" *ngSwitchCase="'A'" class="w3-container city m-5">
        <div *ngFor="let item of this.combustiveis">
          <div *ngIf="item.indCombustivel == 'A'">
            <div class="container text-center" *ngFor="let preco of item.combustivel.precos">
              <div class="row  justify-content-center">
                <div class="col-2 centralizado">
                  <h3 class="text-left comb-titulo">{{ preco.titulo }}</h3>
                  <p class="lable-preco text-left comb-descricao">{{ preco.descricao }} </p>
                </div>

                <div class="col-3 centralizado">
                  <svg mat-raised-button
                       matTooltip="Alteração: {{  item.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ item.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ item.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
                       aria-label="Button that displays a tooltip when focused or hovered over"
                       matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                       data-container="body" data-toggle="popover" data-trigger="hover"
                       xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                       class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                    <path
                      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                  </svg>
                </div>
                <div class="col-4">
                  <input currencyMask type="text" id="fname" name="fname"
                         [(readonly)]="preco.somenteLeitura" [(ngModel)]="preco.preco" autofocus="true"
                         maxlength="9" (keyup)="inputChange($event, preco, 9,'9,99')"
                         (blur)="inputChange($event, preco, 9,'9,99')"
                         (change)="inputChange($event, preco, 9,'9,99')"
                         [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                         [max]="9.999">
                  <p class="situacao-text alt-margin-bottom" *ngIf="preco.id == 'precoNegociado'">
                    Situação: <b>{{item.combustivel.dscStatusAcordo || "Informação ausente no momento"}}</b>
                  </p>
                </div>
                <div class="col-2 centralizado">
                  <button
                    class="btn btn-terceary" (click)="openAjustePreco(ajustePreco, preco, item)">
                    <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;&nbsp;Alterar
                  </button>
                </div>
              </div>
            </div>


          </div>
        </div>

      </div>

      <div id="Gasolina" *ngSwitchCase="'B'" class="w3-container city m-5">
        <div *ngFor="let item of this.combustiveis">
          <div *ngIf="item.indCombustivel == 'B'">
            <div class="container text-center" *ngFor="let preco of item.combustivel.precos">
              <div class="row  justify-content-center">
                <div class="col-2 centralizado">
                  <h3 class="text-left comb-titulo">{{ preco.titulo }}</h3>
                  <p class="lable-preco text-left comb-descricao">{{ preco.descricao }} </p>
                </div>

                <div class="col-3 centralizado">
                  <svg mat-raised-button
                       matTooltip="Alteração: {{  item.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ item.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ item.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
                       aria-label="Button that displays a tooltip when focused or hovered over"
                       matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                       data-container="body" data-toggle="popover" data-trigger="hover"
                       xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                       class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                    <path
                      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                  </svg>
                </div>
                <div class="col-4">
                  <input currencyMask type="text" id="fname" name="fname"
                         [(readonly)]="preco.somenteLeitura" [(ngModel)]="preco.preco" autofocus="true"
                         maxlength="9" (keyup)="inputChange($event, preco, 9,'9,99')"
                         (blur)="inputChange($event, preco, 9,'9,99')"
                         (change)="inputChange($event, preco, 9,'9,99')"
                         [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                         [max]="9.999">
                  <p class="situacao-text alt-margin-bottom" *ngIf="preco.id == 'precoNegociado'">
                    Situação: <b>{{item.combustivel.dscStatusAcordo || "Informação ausente no momento"}}</b>
                  </p>
                </div>
                <div class="col-2 centralizado">
                  <button
                    class="btn btn-terceary" (click)="openAjustePreco(ajustePreco, preco, item)">
                    <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;&nbsp;Alterar
                  </button>
                </div>
              </div>
            </div>


          </div>
        </div>

      </div>

      <div id="Alcool" *ngSwitchCase="'C'" class="w3-container city m-5">
        <div *ngFor="let item of this.combustiveis">
          <div *ngIf="item.indCombustivel == 'C'">
            <div class="container text-center" *ngFor="let preco of item.combustivel.precos">
              <div class="row  justify-content-center">
                <div class="col-2 centralizado">
                  <h3 class="text-left comb-titulo">{{ preco.titulo }}</h3>
                  <p class="lable-preco text-left comb-descricao">{{ preco.descricao }} </p>
                </div>

                <div class="col-3 centralizado">
                  <svg mat-raised-button
                       matTooltip="Alteração: {{  item.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                            Situação: {{ item.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                            Desde: {{ item.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
                       aria-label="Button that displays a tooltip when focused or hovered over"
                       matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                       data-container="body" data-toggle="popover" data-trigger="hover"
                       xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                       class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                    <path
                      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                  </svg>
                </div>
                <div class="col-4">
                  <input currencyMask type="text" id="fname" name="fname"
                         [(readonly)]="preco.somenteLeitura" [(ngModel)]="preco.preco" autofocus="true"
                         maxlength="9" (keyup)="inputChange($event, preco, 9,'9,99')"
                         (blur)="inputChange($event, preco, 9,'9,99')"
                         (change)="inputChange($event, preco, 9,'9,99')"
                         [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                         [max]="9.999">
                  <p class="situacao-text alt-margin-bottom" *ngIf="preco.id == 'precoNegociado'">
                    Situação: <b>{{item.combustivel.dscStatusAcordo || "Informação ausente no momento" }}</b>
                  </p>
                </div>
                <div class="col-2 centralizado">
                  <button
                    class="btn btn-terceary" (click)="openAjustePreco(ajustePreco, preco, item)">
                    <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;&nbsp;Alterar
                  </button>
                </div>
              </div>
            </div>


          </div>
        </div>

      </div>

      <div id="Gasolina Aditivada" *ngSwitchCase="'D'" class="w3-container city m-5">
        <div *ngFor="let item of this.combustiveis">
          <div *ngIf="item.indCombustivel == 'D'">
            <div class="container text-center" *ngFor="let preco of item.combustivel.precos">
              <div class="row  justify-content-center">
                <div class="col-2 centralizado">
                  <h3 class="text-left comb-titulo">{{ preco.titulo }}</h3>
                  <p class="lable-preco text-left comb-descricao">{{ preco.descricao }} </p>
                </div>

                <div class="col-3 centralizado">
                  <svg mat-raised-button
                       matTooltip="Alteração: {{  item.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ item.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ item.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
                       aria-label="Button that displays a tooltip when focused or hovered over"
                       matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                       data-container="body" data-toggle="popover" data-trigger="hover"
                       xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                       class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                    <path
                      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                  </svg>
                </div>
                <div class="col-4">
                  <input currencyMask type="text"
                         [readonly]="preco.somenteLeitura" [(ngModel)]="preco.preco" autofocus="true"
                         maxlength="9" (keyup)="inputChange($event, preco, 9,'9,99')"
                         (blur)="inputChange($event, preco, 9,'9,99')"
                         (change)="inputChange($event, preco, 9,'9,99')"
                         [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                         [max]="9.999">
                  <p class="situacao-text alt-margin-bottom" *ngIf="preco.id == 'precoNegociado'">
                    Situação: <b>{{item.combustivel.dscStatusAcordo || "Informação ausente no momento"}}</b>
                  </p>

                </div>
                <div class="col-2 centralizado">
                  <button
                    class="btn btn-terceary" (click)="openAjustePreco(ajustePreco, preco, item)">
                    <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;&nbsp;Alterar
                  </button>
                </div>
              </div>
            </div>


          </div>
        </div>

      </div>


      <div id="Alcool Aditivado" *ngSwitchCase="'E'" class="w3-container city m-5">
        <div *ngFor="let item of this.combustiveis">
          <div *ngIf="item.indCombustivel == 'E'">
            <div class="container text-center" *ngFor="let preco of item.combustivel.precos">
              <div class="row  justify-content-center">
                <div class="col-2 centralizado">
                  <h3 class="text-left comb-titulo">{{ preco.titulo }}</h3>
                  <p class="lable-preco text-left comb-descricao">{{ preco.descricao }} </p>
                </div>

                <div class="col-3 centralizado">
                  <svg mat-raised-button
                       matTooltip="Alteração: {{  item.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ item.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ item.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
                       aria-label="Button that displays a tooltip when focused or hovered over"
                       matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                       data-container="body" data-toggle="popover" data-trigger="hover"
                       xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                       class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                    <path
                      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                  </svg>
                </div>
                <div class="col-4">
                  <input currencyMask type="text" id="fname" name="fname"
                         [(readonly)]="preco.somenteLeitura" [(ngModel)]="preco.preco" autofocus="true"
                         maxlength="9" (keyup)="inputChange($event, preco, 9,'9,99')"
                         (blur)="inputChange($event, preco, 9,'9,99')"
                         (change)="inputChange($event, preco, 9,'9,99')"
                         [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                         [max]="9.999">
                  <p class="situacao-text alt-margin-bottom" *ngIf="preco.id == 'precoNegociado'">
                    Situação: <b>{{item.combustivel.dscStatusAcordo || "Informação ausente no momento"}}</b>
                  </p>

                </div>
                <div class="col-2 centralizado">
                  <button
                    class="btn btn-terceary" (click)="openAjustePreco(ajustePreco, preco, item)">
                    <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;&nbsp;Alterar
                  </button>
                </div>
              </div>
            </div>


          </div>
        </div>

      </div>

      <div id="Diesel S10 Aditivado" *ngSwitchCase="'T'" class="w3-container city m-5">
        <div *ngFor="let item of this.combustiveis">
          <div *ngIf="item.indCombustivel == 'T'">
            <div class="container text-center" *ngFor="let preco of item.combustivel.precos">
              <div class="row  justify-content-center">
                <div class="col-2 centralizado">
                  <h3 class="text-left comb-titulo">{{ preco.titulo }}</h3>
                  <p class="lable-preco text-left comb-descricao">{{ preco.descricao }} </p>
                </div>

                <div class="col-3 centralizado">
                  <svg mat-raised-button
                       matTooltip="Alteração: {{  item.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ item.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ item.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
                       aria-label="Button that displays a tooltip when focused or hovered over"
                       matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                       data-container="body" data-toggle="popover" data-trigger="hover"
                       xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                       class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                    <path
                      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                  </svg>
                </div>
                <div class="col-4">
                  <input currencyMask type="text" id="fname" name="fname"
                         [readonly]="preco.somenteLeitura"
                         [(ngModel)]="preco.preco" autofocus="true"
                         maxlength="9"
                         (keyup)="inputChange($event, preco, 9,'9,99')"
                         (blur)="inputChange($event, preco, 9,'9,99')"
                         (change)="inputChange($event, preco, 9,'9,99')"
                         [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                         [max]="9.999">
                  <p class="situacao-text alt-margin-bottom" *ngIf="preco.id == 'precoNegociado'">
                    Situação: <b>{{item.combustivel.dscStatusAcordo || "Informação ausente no momento"}}</b>
                  </p>
                </div>
                <div class="col-2 centralizado">
                  <button
                    class="btn btn-terceary" (click)="openAjustePreco(ajustePreco, preco, item)">
                    <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;&nbsp;Alterar
                  </button>
                </div>
              </div>
            </div>


          </div>
        </div>

      </div>

      <div id="Arla" *ngSwitchCase="'U'" class="w3-container city m-5">
        <div *ngFor="let item of this.combustiveis">
          <div *ngIf="item.indCombustivel == 'U'">
            <div class="container text-center" *ngFor="let preco of item.combustivel.precos">
              <div class="row  justify-content-center">
                <div class="col-2 centralizado">
                  <h3 class="text-left comb-titulo">{{ preco.titulo }}</h3>
                  <p class="lable-preco text-left comb-descricao">{{ preco.descricao }} </p>
                </div>

                <div class="col-3 centralizado">
                  <svg mat-raised-button
                       matTooltip="Alteração: {{  item.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ item.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ item.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
                       aria-label="Button that displays a tooltip when focused or hovered over"
                       matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                       data-container="body" data-toggle="popover" data-trigger="hover"
                       xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                       class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                    <path
                      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                  </svg>
                </div>
                <div class="col-4">
                  <input currencyMask type="text" id="fname" name="fname"
                         [(readonly)]="preco.somenteLeitura" [(ngModel)]="preco.preco" autofocus="true"
                         maxlength="9" (keyup)="inputChange($event, preco, 9,'9,99')"
                         (blur)="inputChange($event, preco, 9,'9,99')"
                         (change)="inputChange($event, preco, 9,'9,99')"
                         [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                         [max]="9.999">
                  <p class="situacao-text alt-margin-bottom" *ngIf="preco.id == 'precoNegociado'">
                    Situação: <b>{{item.combustivel.dscStatusAcordo || "Informação ausente no momento"}}</b>
                  </p>
                </div>
                <div class="col-2 centralizado">
                  <button
                    class="btn btn-terceary" (click)="openAjustePreco(ajustePreco, preco, item)">
                    <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;&nbsp;Alterar
                  </button>
                </div>
              </div>
            </div>


          </div>
        </div>

      </div>
    </div>


    <!-- Modal -->
    <ng-template #ajustePreco let-modal>
      <div class="modal-header">
        <h3 class="modal-title">{{ this.combustivelSelecionadoItem.descricaoCombustivel
          }}
        </h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" aria-label="Close"
                (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="modal-body text-color-red">
          <h4>Nesse espaco você pode adicionar o desconto do preço praticado.</h4>
        </div>
        <div class="notificacoes" *ngIf="notificacaoModal" #notificacaoModal>
          <div class="alert" [ngClass]="notificacaoStatus">
                        <span *ngFor="let item of notificacaoMensagens">
                            {{ item }}
                        </span>
            <a href="javascript:void(0)" (click)="fecharNotificacaoModal()" class="close"
               data-dismiss="alert" aria-label="fechar">×</a>
          </div>

        </div>
        <div class="m-1">
          <div>
            <div class="row justify-content-center">
              <div class="col-4 centralizado">
                <h3 class="text-left comb-titulo">{{ itemSelecionadoPrecoUnitario.titulo }}</h3>
                <p class="text-left comb-descricao">{{ itemSelecionadoPrecoUnitario.descricao }}</p>
              </div>

              <div class="col-2 centralizado">
                <svg mat-raised-button
                     matTooltip="Alteração: {{  itemSelecionado.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ itemSelecionado.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ itemSelecionado.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
                     aria-label="Button that displays a tooltip when focused or hovered over"
                     matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                     data-container="body" data-toggle="popover" data-trigger="hover"
                     xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                     class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                  <path
                    d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                </svg>
              </div>
              <div class="col-5 centralizado">
                <input currencyMask type="text"
                       [(ngModel)]="novoPreco.precoAtual"
                       id="fname"
                       name="fname"
                       autofocus="true"
                       placeholder="R$ 0,00"
                       maxlength="9"
                       (keyup)="inputChange($event, novoPreco, preco, '9,99'); calcPercentage($event)"
                       (blur)="inputChange($event, novoPreco, preco, '9,99'); calcPercentage($event)"
                       (change)="inputChange($event, novoPreco, preco, '9,99'); calcPercentage($event)"
                       [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                       [max]="9.999">
              </div>
            </div>
          </div>
        </div>

        <div class="m-1" *ngIf="precoClicado.id != 'precoUnitario'">
          <div>
            <div class="row justify-content-center">
              <div class="col-4 centralizado">
                <div class="form-group">
                  <p for="sel1">Desconto para ser<br>aplicado ao preço<br> SPS da CTF:</p>
                  <select [(ngModel)]="tipoDesconto" id="sel1" name="sellist1">
                    <option value="descporcentagem">Desc %</option>
                    <option value="descreais">Desc R$</option>
                  </select>
                  <br>

                </div>
              </div>

              <div class="col-2 centralizado">
                <svg mat-raised-button
                     matTooltip="Alteração: {{  itemSelecionado.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ itemSelecionado.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ itemSelecionado.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
                     aria-label="Button that displays a tooltip when focused or hovered over"
                     matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                     data-container="body" data-toggle="popover" data-trigger="hover"
                     xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                     class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                  <path
                    d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                </svg>
              </div>
              <div class="col-5 centralizado">
                <input currencyMask *ngIf="tipoDesconto == 'descporcentagem'"
                       class="preco-number-size-red" maxlength="6"
                       [(ngModel)]="novoPreco.descontoPorcentagem" type="text"
                       (keyup)="calcPercentage($event)"
                       (blur)="calcPercentage($event)"
                       (change)="calcPercentage($event)" placeholder="%"
                       [options]="{ prefix: '', thousands: '.', decimal: ',', precision: 2 }"
                       [max]="9.999"/>


                <input currencyMask *ngIf="tipoDesconto == 'descreais'"
                       class="preco-number-size-red" maxlength="9"
                       [(ngModel)]="novoPreco.descontoReal" type="text"
                       (keyup)="inputChange($event, novoPreco, preco, '9,99'); calcPercentage($event)"
                       (blur)="inputChange($event, novoPreco, preco, '9,99'); calcPercentage($event)"
                       (change)="inputChange($event, novoPreco, preco, '9,99'); calcPercentage($event)"
                       [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                       [max]="9.999" placeholder="R$"/>
              </div>
            </div>
          </div>
        </div>

        <div class="m-1" *ngIf="precoClicado.id != 'precoUnitario'">
          <div>
            <div class="row justify-content-center">
              <div class="col-4 centralizado">
                <h3 class="text-left comb-titulo">{{ precoClicado.titulo }}</h3>
                <p class="text-left comb-descricao">{{ precoClicado.descricao }}</p>
              </div>

              <div class="col-2 centralizado">
                <svg mat-raised-button
                     matTooltip="Alteração: {{  itemSelecionado.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ itemSelecionado.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ itemSelecionado.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
                     aria-label="Button that displays a tooltip when focused or hovered over"
                     matTooltipClass="my-tooltip" matTooltipPosition="after" type="button"
                     data-container="body" data-toggle="popover" data-trigger="hover"
                     xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                     class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
                  <path
                    d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                </svg>
              </div>
              <div class="col-5 centralizado">
                <input currencyMask type="text" id="fname" name="fname" autofocus="true"
                       placeholder="R$ 0,00" [(ngModel)]="novoPreco.precoNegociado" maxlength="9"
                       (keyup)="calcCampoPercentage($event)"
                       (blur)="calcCampoPercentage($event)"
                       (change)="calcCampoPercentage($event)" placeholder="R$"
                       [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                       [max]="9.999">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="addPrice(); "><i class="fa fa-save"
                                                                                aria-hidden="true"></i>&nbsp;&nbsp;Salvar
        </button>
      </div>
    </ng-template>

    <!-- Modal Ajuda-->
    <ng-template #ajudaModel let-modal>
      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalLabel">Perguntas frequentes</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" aria-label="Close"
                (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div id="ajudaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <ngb-accordion id="accordion" #acc="ngbAccordion" [closeOthers]="true"
                             activeIds="collapseOne">
                <ngb-panel id="collapseOne">
                  <ng-template ngbPanelTitle class="card-header" id="headingOne">
                    <h5>
                      O que é o “Preço de Bomba”?
                    </h5>
                  </ng-template>
                  <ng-template ngbPanelContent class="collapse show" aria-labelledby="headingOne"
                               data-parent="#accordion">
                    <div class="card-body">
                      É o preço praticado pelo posto.
                    </div>
                  </ng-template>
                </ngb-panel>
                <ngb-panel>
                  <ng-template ngbPanelTitle class="card-header" id="headingTwo">
                    <h5>
                      O que é o “Preço para UVE”?
                    </h5>
                  </ng-template>
                  <ng-template ngbPanelContent id="collapseTwo" class="collapse"
                               aria-labelledby="headingTwo" data-parent="#accordion">
                    <div class="card-body">
                      É o preço que será utilizado para todos os abastecimentos de UVE no posto,
                      desde
                      que
                      a
                      frota não possua um AEP (Acordo Especial de Preço), nesse caso prevalece o
                      AEP.
                      <br>
                      Esse preço será apresentado no localizador de postos da CTF.
                    </div>
                  </ng-template>
                </ngb-panel>
                <ngb-panel>
                  <ng-template ngbPanelTitle class="card-header" id="headingThree">
                    <h5>
                      O que é o “Preço para Cartão”?
                    </h5>
                  </ng-template>
                  <ng-template ngbPanelContent id="collapseThree" class="collapse"
                               aria-labelledby="headingThree" data-parent="#accordion">
                    <div class="card-body">
                      É o preço que será praticado pelo posto para abastecimentos de cartão.
                      Se o valor informado no POS for superior a esse valor será concedido um
                      desconto
                      automático no momento da venda para que esse valor seja respeitado.
                      Se o valor informado no POS for inferior a esse valor o mesmo será mantido.
                      Esse preço será apresentado no localizador de postos da CTF.
                    </div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel>
                  <ng-template ngbPanelTitle class="card-header" id="headingFour">
                    <h5>
                      O que é o “Preço para Frete”?
                    </h5>
                  </ng-template>
                  <ng-template ngbPanelContent id="collapseFour" class="collapse"
                               aria-labelledby="headingFour" data-parent="#accordion">
                    <div class="card-body">
                      É o preço que será praticado pelo posto para abastecimentos de Frete. <br>
                      Se o valor informado no POS for superior a esse valor será concedido um
                      desconto
                      automático no momento da venda para que esse valor seja respeitado.<br>
                      Se o valor informado no POS for inferior a esse valor o mesmo será mantido.
                      <br>
                      Esse preço será apresentado no localizador de postos da CTF.
                    </div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel>
                  <ng-template ngbPanelTitle class="card-header" id="headingFive">
                    <h5 class="accordion-header">
                      O que é SPS?
                    </h5>
                  </ng-template>
                  <ng-template ngbPanelContent id="collapseFive" class="collapse"
                               aria-labelledby="headingFive" data-parent="#accordion">
                    <div class="card-body">
                      SPS ( Sistema de preço simplificado ) é a ferramenta do Sistema CTF pela
                      qual a
                      CTF
                      divulga e oferece a determinadas Frotas o Preço Negociado CTF para a
                      aquisição
                      de
                      Combustível e demais produtos e serviços CTF, equivalente à proposição de um
                      AEP
                      entre
                      posto e frota.
                      A inclusão de um preço para abastecimentos de UVE indica a aceitação da
                      participação
                      do
                      posto no SPS.

                      <a href="https://www.portalctf.com.br/portalposto/PrecoCombustivel/acordo.pdf"
                         target="_blank"> Segue
                        termo de adesão do SPS:</a>

                    </div>
                  </ng-template>
                </ngb-panel>
              </ngb-accordion>

            </div>
          </div>
        </div>
      </div>
    </ng-template>


    <app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading">
    </app-mat-spinner-overlay>
  </div>
</div>
